import { FC } from 'react';
import { useIntl } from 'react-intl';

type CrossBrowserDirtyWarningProps = {
  isDirty: boolean;
  onReload: () => void;

  canReload: boolean;
};

export const CrossBrowserDirtyWarning: FC<CrossBrowserDirtyWarningProps> = ({ isDirty, onReload, canReload }) => {
  const { formatMessage } = useIntl();

  if (!isDirty) {
    return null;
  }
  return (
    <div data-e2e="dirty-message" className="alert alert-discreet-warning text-center my-0">
      <strong>
        <i className="icon icon-md pb-1 pe-3">warning</i>
        {formatMessage({ id: 'tabs.modifiedSession' })}
      </strong>
      {canReload && (
        <button type="button" className="btn btn-lg btn-warning ms-4" onClick={onReload}>
          <i className="icon icon-lg me-1">autorenew</i>
          Reload form
        </button>
      )}
    </div>
  );
};
